var __create = Object.create;
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __markAsModule = (target) => __defProp(target, "__esModule", { value: true });
var __export = (target, all) => {
  __markAsModule(target);
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __reExport = (target, module2, desc) => {
  if (module2 && typeof module2 === "object" || typeof module2 === "function") {
    for (let key of __getOwnPropNames(module2))
      if (!__hasOwnProp.call(target, key) && key !== "default")
        __defProp(target, key, { get: () => module2[key], enumerable: !(desc = __getOwnPropDesc(module2, key)) || desc.enumerable });
  }
  return target;
};
var __toModule = (module2) => {
  return __reExport(__markAsModule(__defProp(module2 != null ? __create(__getProtoOf(module2)) : {}, "default", module2 && module2.__esModule && "default" in module2 ? { get: () => module2.default, enumerable: true } : { value: module2, enumerable: true })), module2);
};
__export(exports, {
  Subquestion: () => Subquestion
});
var import_invalidValue = __toModule(require("../error/invalidValue"));
var import_subquestionCannotBeCreatedOutsideDende = __toModule(require("../error/subquestionCannotBeCreatedOutsideDende"));
var import_subquestionCannotHaveOptions = __toModule(require("../error/subquestionCannotHaveOptions"));
var import_subquestionCannotHaveValue = __toModule(require("../error/subquestionCannotHaveValue"));
var import_utils = __toModule(require("../utils"));
var import_base = __toModule(require("./base"));
class Subquestion extends import_base.Base {
  constructor(dende, form) {
    super(dende, form);
  }
  static create(dende, form) {
    if (dende.getSubquestions()) {
      throw new import_subquestionCannotBeCreatedOutsideDende.SubquestionCannotBeCreatedOutsideDende();
    }
    return new Subquestion(dende, form);
  }
  getRenderForm() {
    const result = {
      error: this.getValidationErrorMessage(),
      group: this.form.group,
      helpButtonUrl: this.form.helpButtonUrl,
      id: this.form.id,
      label: this.form.question,
      placeholder: this.form.placeholder,
      questionType: this.form.questionType,
      type: this.form.type,
      onEdit: this.form.editWarning,
      options: this.form.options,
      value: this.value
    };
    return result;
  }
  getOptions() {
    if (!this.isSingleoption()) {
      throw new import_subquestionCannotHaveOptions.SubquestionCannotHaveOptions(this.getId());
    }
    return this.form.options;
  }
  getValidations() {
    if (this.isSingleoption()) {
      return __spreadProps(__spreadValues({}, this.form.validations), {
        options: this.getOptions().map(({ value }) => value),
        optionsType: this.form.optionsType
      });
    }
    return this.form.validations || {};
  }
  getValidationError() {
    if (this.isValid()) {
      return;
    }
    return (0, import_utils.getValueValidationMessage)(this.value, this.form.validationType);
  }
  isSingleoption() {
    return this.getType() === "Singleoption";
  }
  isValid() {
    return this.isValueValid(this.value);
  }
  setValue(value) {
    if (!this.dende.isMultioption()) {
      throw new import_subquestionCannotHaveValue.SubquestionCannotHaveValue(this.getId());
    }
    if (!this.isValueLegal(value)) {
      throw new import_invalidValue.InvalidValue(this.form.validationType, value);
    }
    this.value = value;
  }
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Subquestion
});
